<!--for lock all control during loading mat-chip list and mat select must be managed manualy-->
<fieldset class="groups-form-dialog disabled-border-fieldset-when-loading"
  [disabled]="loading">
  <div class="groups-form-dialog__container dialog-content-wrapper">

    @if (isModal) {
      <div
        class="groups-form-dialog__header mb-0"
        mat-dialog-title>
        <h2>
          <span translate>{{ dialogTitle }}</span>
          @if (entity.name) {
            <span class="entity-name">{{ entity.name }}</span>
          }
        </h2>
        <button class="close"
                data-e2e="group-form-close"
          (click)="dialogRef.close()"
          aria-label="Close dialog">
          <mat-icon svgIcon="cross"></mat-icon>
        </button>
      </div>
    }

    <div class="groups-form-dialog__content m-0"
      mat-dialog-content>

      <form class="groups-form-dialog__form"
        id="groups-form-dialog-main-form"
        [formGroup]="entityForm"
        name="entityForm"
        novalidate>

        <!-- Color Field -->
        @if (getFieldByLabel('color')) {
          <app-color-picker [selectedColor]="selectedColor"
            (colorChange)="selectColor($event)"
          [colors]="colors"></app-color-picker>
        }
        <!-- Nickname Field -->
        @if (getFieldByLabel('nickname')) {
          <div class=""
            fxLayout="row"
            fxLayoutAlign="start start"
            >
            <mat-form-field fxFlex floatLabel="auto">
              <mat-label>{{ 'groups-management.choose_nickname' | translate }}</mat-label>
              <input
                [formControl]="entityForm.get('nickname')"
                [matAutocomplete]="auto"
                name="nickname"
                data-e2e="group-form-nickname"
                id="group-form-control-nickname"
                formControlName="nickname"
                matInput
                [required]="isRequired('nickname')">
                @if (entityFormErrors?.nickname?.nameInvalid) {
                  <mat-error>
                    {{ 'groups-management.learner_nickname_invalid' | translate }}
                  </mat-error>
                }
                @if (entityFormErrors?.nickname?.taken) {
                  <mat-error>
                    {{ 'account-management.nickname_taken' | translate }}
                  </mat-error>
                }
                @if (entityFormErrors?.nickname?.nonexistent) {
                  <mat-error>
                    {{ 'account-management.nickname_nonexistent' | translate }}
                  </mat-error>
                }
                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFnNickname">
                  @for (learner of filteredLearnersOptions | async; track learner) {
                    <mat-option [value]="learner">
                      {{ learner }}
                    </mat-option>
                  }
                </mat-autocomplete>
              </mat-form-field>
            </div>
          }

          <!-- Email Field -->
          @if (getFieldByLabel('email')) {
            <div
              class=""
              fxLayout="row"
              fxLayoutAlign="start start"
              >
              <mat-form-field fxFlex>
                <mat-label>{{ 'groups-management.your_email' | translate }}</mat-label>
                <input
                  matInput
                  data-e2e="group-form-email"
                  formControlName="email"
                  required>
                </mat-form-field>
              </div>
            }
            <!-- age Fields is store in same than birthday it's one or other not both-->
            @if (getFieldByLabel('age') && !getFieldByLabel('birthMonth')) {
              <div class="" fxLayout="row" fxLayoutAlign="start start"
                >
                <mat-form-field fxFlex>
                  <mat-label>{{ 'groups-management.your_age' | translate }}</mat-label>
                  <input
                    type="number"
                    min="0"
                    matInput
                    formControlName="age"
                    [required]="isRequired('age')">
                  </mat-form-field>
                </div>
              }

              <!-- Birthday Fields -->
              @if (getFieldByLabel('birthMonth')) {
                <div class="" fxLayout="row" fxLayoutAlign="start start">
                  <mat-form-field fxFlex>
                    <mat-label>{{ 'groups-management.birthmonth' | translate }}</mat-label>
                    <mat-select [disabled]="loading"
                      name="birthMonth" data-e2e="group-form-birthMonth"
                      formControlName="birthMonth"
                      [required]="isRequired('birthMonth')">
                      @for (month of months; track month) {
                        <mat-option [value]="month">{{ month }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field fxFlex>
                    <mat-label>{{ 'groups-management.birthyear' | translate }}</mat-label>
                    <mat-select [disabled]="loading" data-e2e="group-form-birthYear"
                      name="birthYear"
                      formControlName="birthYear"
                      [required]="isRequired('birthYear')">
                      @for (year of years; track year) {
                        <mat-option [value]="year">{{ year }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              }
              <!--educational level used for learner sometimes store data in level in back : !!cannot be used if level field is used!!-->
              @if (getFieldByLabel('educationalLevel')) {
                <div
                  class=""
                  fxLayout="row"
                  fxLayoutAlign="start start"
                  >
                  <mat-form-field fxFlex>
                    <mat-label>{{ 'groups-management.chose_educationnal_level' | translate }}</mat-label>
                    <mat-select
                      name="educationalLevel"
                      data-e2e="group-form-educationalLevel"
                      formControlName="educationalLevel"
                      [required]="isRequired('educationalLevel')">
                      @for (level of selects?.educationalLevels(); track level) {
                        <mat-option
                          [value]="level?.id"> {{ level.get('label') }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              }

              <!-- Gender Field -->
              @if (getFieldByLabel('gender')) {
                <div class="" fxLayout="row" fxLayoutAlign="start start">
                  <mat-form-field fxFlex>
                    <mat-label>{{ 'groups-management.gender' | translate }}</mat-label>
                    <mat-select [disabled]="loading"
                      name="gender"
                      formControlName="gender"
                                data-e2e="group-form-gender"
                      [required]="isRequired('gender')">
                      @for (gender of genders; track gender) {
                        <mat-option [value]="gender">{{ gender }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              }

              <!-- dyspraxic disorder Field -->
              @if (getFieldByLabel('dyspraxic')) {
                <div class="" fxLayout="row" fxLayoutAlign="start start">
                  <mat-form-field fxFlex>
                    <mat-label>{{ 'groups-management.dyspraxic' | translate }}</mat-label>
                    <mat-select [disabled]="loading"
                                data-e2e="group-form-dyspraxic"
                      name="dyspraxic"
                      formControlName="dyspraxic">
                      @for (dyspraxicTrouble of dyspraxicTroubleList; track dyspraxicTrouble) {
                        <mat-option
                          [value]="dyspraxicTrouble">
                          {{ dyspraxicTrouble }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              }

              <!-- other disorder Field -->
              @if (getFieldByLabel('disorder')) {
                <div class="" fxLayout="row" fxLayoutAlign="start start">
                  <mat-form-field fxFlex>
                    <mat-label>{{ 'groups-management.disorder' | translate }}</mat-label>
                    <mat-select [disabled]="loading"
                      name="disorder"
                                data-e2e="group-form-disorder"
                      formControlName="disorder" multiple>
                      @for (trouble of otherTroubleList; track trouble) {
                        <mat-option
                          [value]="trouble">
                          {{ trouble }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              }

              <!-- Type Field -->
              @if (getFieldByLabel('type')) {
                <div
                  class=""
                  fxLayout="row"
                  fxLayoutAlign="start start"
                  >
                  <mat-form-field fxFlex>
                    <mat-label>{{ 'groups-management.assign_type' | translate }}</mat-label>
                    <mat-select
                        data-e2e="group-form-type"
                      [disabled]="loading"
                      name="type"
                      formControlName="type">
                      @for (type of selects.types(); track type) {
                        <mat-option
                          [value]="type">{{ selectType(type) | translate }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              }

              <!-- Groupname Field -->
              @if (getFieldByLabel('groupname')) {
                <div
                  class=""
                  fxLayout="row"
                  fxLayoutAlign="start start"
                  >
                  <mat-form-field fxFlex="100" floatLabel="auto">
                    <mat-label>{{ 'groups-management.chose_class_name' | translate }}</mat-label>
                    <input matInput type="text"
                      formControlName="groupname"
                           data-e2e="group-form-groupname"
                      [required]="isRequired('groupname')">
                      @if (entityFormErrors?.groupname?.required) {
                        <mat-error>
                          {{ 'generic.field.required' | translate }}
                        </mat-error>
                      }
                      @if (entityFormErrors?.groupname?.alreadyExist) {
                        <mat-error>
                          {{ 'groups-management.group_name_already_used' | translate }}
                        </mat-error>
                      }
                    </mat-form-field>
                  </div>
                }

                <!-- Workgroupname Field -->
                @if (getFieldByLabel('workgroupname')) {
                  <div
                    class=""
                    fxLayout="row"
                    fxLayoutAlign="start start"
                    >
                    <mat-form-field fxFlex floatLabel="auto">
                      <mat-label>{{ 'groups-management.chose_group_name' | translate }}</mat-label>
                      <input
                        name="workgroupname"
                        data-e2e="group-form-workgroupname"
                        formControlName="workgroupname"
                        matInput
                        [required]="isRequired('workgroupname')">
                        @if (entityFormErrors?.workgroupname?.required) {
                          <mat-error>
                            {{ 'generic.field.required' | translate }}
                          </mat-error>
                        }
                        @if (entityFormErrors?.workgroupname?.alreadyExist) {
                          <mat-error>
                            {{ 'groups-management.name_already_used' | translate }}
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  }

                  <!-- PostalCode & Title fields -->
                  @if (getFieldByLabel('postalCode') || getFieldByLabel('title')) {
                    <div fxLayout="row"
                      fxLayoutAlign="start start"
                      fxLayoutGap="20px"
                      >
                      <!-- Postal code -->
                      @if (getFieldByLabel('postalCode')) {
                        <mat-form-field fxFlex="20">
                          <mat-label>{{ 'generic.postal-code' | translate }}</mat-label>
                          <input type="text"
                            matInput
                                 data-e2e="group-form-postal-code"
                            [formControl]="myCodePostalControl"
                            [matAutocomplete]="auto">
                            <mat-autocomplete #auto="matAutocomplete"
                              (optionSelected)="applyFilters($event, 'postalCode')">
                              @for (option of filteredPostalCodes | async; track option) {
                                <mat-option appAriaTitle
                                  [value]="option">
                                  {{ option }}
                                </mat-option>
                              }
                            </mat-autocomplete>
                          </mat-form-field>
                        }
                        <!-- title institution for new add -->
                        @if (getFieldByLabel('title')) {
                          <mat-form-field fxFlex>
                            <mat-label>{{ 'generic.name' | translate }}</mat-label>
                            <input [formControl]="institutionTitleFormControl" data-e2e="group-form-institution" matInput>
                          </mat-form-field>
                        }
                      </div>
                    }
                    @if (hasLaunchSearchButton()) {
                      <div
                        fxLayout="row"
                        fxLayoutAlign="start start"
                        class="mb-12">
                        <button
                          mat-raised-button
                          data-e2e="group-form-save"
                          class="save-button mat-accent"
                          (click)="launchSearch(true)">{{ 'generic.search' | translate }}
                        </button>
                      </div>
                    }


                    @if (getFieldByLabel('institution')) {
                      <div class=" h-400">
                        <table mat-table #table [dataSource]="dataSource"
                          [@animateStagger]="{value:'50'}">
                          <ng-container matColumnDef="field">
                            <th mat-header-cell
                              *matHeaderCellDef>{{ 'groups-management.select-institution' | translate }}
                            </th>
                            <td mat-cell *matCellDef="let entity">
                              <p class="text-truncate">{{ entity.field }}</p>
                            </td>
                          </ng-container>
                          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                          <tr mat-row *matRowDef="let entity; columns: displayedColumns;"
                            class="entity"
                            (click)="selectedInstitution(entity)"
                            [ngClass]="{'selected': institutionSelected.id === entity.id}"
                            matRipple
                            [@animate]="{value:'*',params:{y:'100%'}}">
                          </tr>
                        </table>
                      </div>
                    }


                    <!-- Password Field -->
                    @if (getFieldByLabel('password') && hasPasswordField()  && !isJoiningExistingLearner) {
                      <div
                        class=""
                        fxLayout="row"
                        fxLayoutAlign="start start"
                        >
                        <mat-form-field fxFlex floatLabel="auto">
                          <mat-label>{{ 'groups-management.chose_password' | translate }}</mat-label>
                          @if (action === 'new') {
                            <input
                              name="password"
                              data-e2e="group-form-password"
                              formControlName="password"
                              matInput
                              type="new-password"
                              [required]="isRequired('password')"
                              >
                          }
                          @if (action !== 'new') {
                            <input
                                data-e2e="group-form-password2"
                              name="password"
                              formControlName="password"
                              matInput
                              type="new-password"
                              >
                          }
                        </mat-form-field>
                      </div>
                    }
                    @if (getFieldByLabel('passwordConfirm') && hasPasswordField()) {
                      <div
                        class=""
                        fxLayout="row"
                        fxLayoutAlign="start start"
                        >
                        <mat-form-field fxFlex>
                          <mat-label>{{ 'account-management.password-confirm' | translate }}</mat-label>
                          <input matInput type="password"
                                 data-e2e="group-form-password-confirm"
                            formControlName="passwordConfirm" required>
                            @if (entityFormErrors?.passwordConfirm?.required) {
                              <mat-error>
                                {{ 'account-management.password-confirm.required' | translate }}
                              </mat-error>
                            }
                            @if (entityFormErrors?.passwordConfirm?.passwordsNotMatch) {
                              <mat-error>
                                {{ 'account-management.password-confirm.not-identical' | translate }}
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                      }

                      @if (!hasPasswordField()) {
                        <div
                          class=""
                          fxLayout="row"
                          fxLayoutAlign="start start"
                          >
                          {{ 'group-management.sso_user_no_edition' | translate }}
                        </div>
                      }

                      <!-- Groups field-->
                      @if (getFieldByLabel('groups') && canAttachToGroup()) {
                        <div
                          class=""
                          fxLayout="row"
                          fxLayoutAlign="space-around center"
                          >
                          <mat-form-field fxFlex="100" floatLabel="auto">
                            <mat-label>{{ 'groups-management.assign_to_class' | translate }}</mat-label>
                            <mat-chip-grid #chipList>
                              @for (chip  of chips; track chip ) {
                                <mat-chip-row
                                  [removable]="removable"
                                  (removed)="remove(chip, 'groups')">
                                  {{ chip }}
                                  @if (removable) {
                                    <mat-icon matChipRemove>cancel</mat-icon>
                                  }
                                </mat-chip-row>
                              }
                              <input
                                  data-e2e="group-form-chiplist"
                                #groupsChipInput
                                [matAutocompleteDisabled]="(groupNameClassroomSelected!== null && groupNameClassroomSelected!==undefined && groupNameClassroomSelected !=='')"
                                [formControl]="chipsCtrl"
                                [matAutocomplete]="auto"
                                [matChipInputFor]="chipList"
                                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                [matChipInputAddOnBlur]="addOnBlur"
                                [ngClass]="(groupNameClassroomSelected !== null && groupNameClassroomSelected !== undefined && groupNameClassroomSelected !== '')?'chip-read-only':''"
                                />
                                @if (entityFormErrors?.groups?.required) {
                                  <mat-error>
                                    {{ 'generic.field.required' | translate }}
                                  </mat-error>
                                }
                              </mat-chip-grid>
                              <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event, 'groups')">
                                @for (chip of filteredChips | async; track chip) {
                                  <mat-option appAriaTitle [value]="chip">
                                    {{ chip }}
                                  </mat-option>
                                }
                              </mat-autocomplete>
                            </mat-form-field>
                          </div>
                        }

                        @if (getFieldByLabel('workgroups') && canAttachToWorkgroup()) {
                          <div class=""
                            fxLayout="row"
                            fxLayoutAlign="space-around center"
                            >
                            <mat-form-field fxFlex="100" floatLabel="auto">
                              <mat-label>{{ 'filter.workgroup' | translate }}</mat-label>
                              <mat-chip-grid [disabled]="loading" #workgroupChipList>
                                @for (workgroupChip  of workgroupChips; track workgroupChip ) {
                                  <mat-chip-row
                                    [removable]="workgroupRemovable"
                                    (removed)="remove(workgroupChip, 'workgroup')">
                                    {{ workgroupChip }}
                                    @if (workgroupRemovable) {
                                      <mat-icon matChipRemove>cancel</mat-icon>
                                    }
                                  </mat-chip-row>
                                }
                                <input
                                    data-e2e="group-form-workgroupinput"
                                  #workgroupChipInput
                                  [matAutocompleteDisabled]="(groupNameSelected!== null && groupNameSelected!==undefined && groupNameSelected !=='')"
                                  [formControl]="workgroupCtrl"
                                  [matAutocomplete]="workgroup"
                                  [matChipInputFor]="workgroupChipList"
                                  [matChipInputSeparatorKeyCodes]="workgroupSeparatorKeysCodes"
                                  [matChipInputAddOnBlur]="workgroupAddOnBlur"
                                  [ngClass]="(groupNameSelected !== null && groupNameSelected !== undefined && groupNameSelected !== '') ?'chip-read-only':''"/>
                                </mat-chip-grid>
                                <mat-autocomplete #workgroup="matAutocomplete"
                                  (optionSelected)="selected($event, 'workgroups')">
                                  @for (workgroupChip of workgroupFilteredChips | async; track workgroupChip) {
                                    <mat-option appAriaTitle
                                      [value]="workgroupChip">
                                      {{ workgroupChip }}
                                    </mat-option>
                                  }
                                </mat-autocomplete>
                              </mat-form-field>
                            </div>
                          }

                          <!-- Checkbox Column -->
                          @if (getFieldByLabel('parentalConsent')) {
                            <div
                              class=""
                              fxLayout="row"
                              fxLayoutAlign="space-around center"
                              >
                              <mat-checkbox formControlName="parentalConsent"
                                            data-e2e="group-form-parental-consent"
                                (keydown.enter)="toggleParentalConsent()">
                                {{ 'generic.parental_consent' | translate }}
                              </mat-checkbox>
                            </div>
                          }

                          <!-- Level Field -->
                          @if (getFieldByLabel('level')) {
                            <div
                              class=""
                              fxLayout="row"
                              fxLayoutAlign="start start"
                              >
                              <mat-form-field fxFlex floatLabel="auto">
                                <mat-label>{{ 'groups-management.chose_level' | translate }}</mat-label>
                                @if (settings.levelsWidget == 'select') {
                                  <mat-select
                                      data-e2e="group-form-level"
                                    [disabled]="loading"
                                    name="level" [required]="isRequired('level')"
                                    formControlName="level">
                                    @for (level of selects?.levels(); track level) {
                                      <mat-option
                                        [value]="level.get('name')"> {{ level.get('name') }}
                                      </mat-option>
                                    }
                                  </mat-select>
                                }
                                @if (settings.levelsWidget != 'select') {
                                  <input
                                      data-e2e="group-form-level"
                                    name="level"
                                    formControlName="level"
                                    placeholder="{{ 'groups-management.chose_level' | translate }}"
                                    matInput>
                                }
                              </mat-form-field>
                            </div>
                          }

                          @if (getFieldByLabel('schoolyear_term')) {
                            <div
                              class=""
                              fxLayout="row"
                              fxLayoutAlign="start start"
                              >
                              <mat-form-field fxFlex>
                                <mat-label>{{ 'groups-management.chose_school.year' | translate }}</mat-label>
                                <mat-select [disabled]="loading"
                                            data-e2e="group-form-schoolyear_term"
                                  name="schoolyear_term"
                                  placeholder="{{ 'groups-management.chose_school.year' | translate }}"
                                  formControlName="schoolyear_term">
                                  @for (shoolYear of selects?.schoolYears(); track shoolYear) {
                                    <mat-option
                                      [value]="shoolYear.id.toString()"> {{ shoolYear.get('name') + '-' + (+shoolYear.get('name') + 1) }}
                                    </mat-option>
                                  }
                                </mat-select>
                              </mat-form-field>
                            </div>
                          }

                          <!-- institutions Field edit or add class-->
                          @if (getFieldByLabel('parent')) {
                            <div class=""
                              fxLayout="row"
                              fxLayoutAlign="start start"
                              >
                              <mat-form-field fxFlex>
                                <mat-label>{{ 'groups-management.target_institution' | translate }}</mat-label>
                                <mat-select [disabled]="loading"
                                            data-e2e="group-form-parent"
                                  name="parent"
                                  placeholder="{{ 'groups-management.target_institution' | translate }}"
                                  formControlName="parent">
                                  @for (institution of institutions; track institution) {
                                    <mat-option
                                      [value]="institution"> {{ institution.field }}
                                    </mat-option>
                                  }
                                </mat-select>
                              </mat-form-field>
                            </div>
                          }

                        </form>

                      </div>

                      @if (getFieldByLabel('institution')) {
                        <div
                          fxFlex="100"
                          fxLayoutAlign="center start">
                          <mat-paginator
                            [length]="countEntities"
                            [pageIndex]="pageIndex"
                            [pageSize]="pageRange"
                            (page)="onPaginateChange($event)">
                          </mat-paginator>
                        </div>
                      }

                      <div class="groups-form-dialog__actions"
                        mat-dialog-actions>
                        <ng-container>
                          <button class="groups-form-dialog__save-button save-button"
                                  data-e2e="group-form-save"
                            [attr.aria-label]="(loading ? 'generic.loading' : 'generic.save') | translate"
                            [matTooltip]="(loading ? 'generic.loading' : 'generic.save') | translate"
                            [attr.loading]="loading ? '' : null"
                            [attr.aria-busy]="loading ? true : null"
                            [attr.aria-disabled]="loading ? true : null"
                            [disabled]="entityForm.invalid"
                            (click)="close(entityForm)">
                            @if (isModal) {
                              <span>{{ 'generic.validate' | translate }}</span>
                            }
                            <!--for on line editing we not use text but icon-->
                            @if (!isModal) {
                              <mat-icon svgIcon="groups-form-add"></mat-icon>
                            }
                          </button>
                        </ng-container>

                        <!--for cancel action of editing or adding when we edit in a row context-->
                        @if (!isModal && (originEntity.data.action === 'edit' || originEntity.data.action === 'new')) {
                          <button class="groups-form-dialog__close-button save-button"
                            [attr.aria-label]="'generic.close' | translate"
                            [matTooltip]="'generic.close' | translate"
                            [disabled]="loading"
                            (click)="cancelEditingRow()"
                                  data-e2e="group-form-save">
                            <!--for on line editing we not use text but icon-->
                            <mat-icon svgIcon="cross"></mat-icon>
                          </button>
                        }
                      </div>

                      @if (getFieldByLabel('info')) {
                        <div class="groups-form-dialog__infobox-wrapper">
                          <aside class="groups-form-dialog__infobox">
                            <mat-icon class="groups-form-dialog__infobox-icon"
                              svgIcon="info">
                            </mat-icon>
                            <p class="groups-form-dialog__infobox-text">
                              {{ 'groups-management.add_learner_info' | translate }}
                            </p>
                          </aside>
                        </div>
                      }

                    </div>
                  </fieldset>